import axios from 'axios';

const cancelar = (idCotacao, id) => axios.put(`/cotacoes/${idCotacao}/produtos/${id}/cancelar`, {});
const getCompra = (idCotacao, id) => axios.get(`/cotacoes/${idCotacao}/produtos/${id}/compra`);
const getProdutos = idCotacao => axios.get(`/cotacoes/${idCotacao}/produtos`);

export default {
  cancelar,
  getCompra,
  getProdutos,
};
